<template>
  <!--页面根元素-->
  <div class="idm_render_engine_container">
    <!--页面渲染的容器-->
    <transition-group
      v-on:after-enter="transitionAfterEnter"
      tag="div"
      class="idm_render_engine_router_container"
      name="slide-fade"
    >
      <template v-for="(page, index) in AppPageList">
        <component
          v-if="page.keep"
          :is="'Page'"
          :key="page.pageid + index"
          :ref="`idm_page_${page.routerId}`"
          :styleObject="page.display === false ? { display: 'none' } : {}"
          :pageid="page.pageid"
          :routerId="page.routerId"
          :devpreview="page.devpreview"
          :mainPage="page.mainPage"
          :index="index"
          @mainPageSettingHandle="mainPageSettingHandle"
        />
      </template>
    </transition-group>
    <idm-a-drawer
      v-if="!drawerPropData.placement?pagePropData.drawerPlacement != 'center':drawerPropData.placement != 'center'"
      :title="(pagePropData.drawerTitleShow||drawerPropData.showTitle===true)&&drawerPropData.showTitle!==false ? drawerPropData.title||pagePropData.drawerTitle : ''"
      :placement="drawerPropData.placement || pagePropData.drawerPlacement || 'right'"
      :closable="pagePropData.drawerClosable === false ? false : true"
      :destroyOnClose="pagePropData.drawerDestroyOnClose"
      :maskClosable="pagePropData.drawerMaskClosable === false ? false : true"
      :mask="pagePropData.drawerMask === false ? false : true"
      :keyboard="pagePropData.drawerKeyboarde === false ? false : true"
      :maskStyle="
        commonCustomEventFunHandle(pagePropData, 'drawerMaskStyleFunction') || {}
      "
      :wrapStyle="
        commonCustomEventFunHandle(pagePropData, 'drawerWrapStyleFunction') || {}
      "
      :drawerStyle="commonCustomEventFunHandle(pagePropData, 'drawerStyleFunction') || {}"
      :headerStyle="
        commonCustomEventFunHandle(pagePropData, 'drawerHeaderStyleFunction') || {}
      "
      :bodyStyle="
        commonCustomEventFunHandle(pagePropData, 'drawerBodyStyleFunction') || {}
      "
      :width="drawerPropData.width ||pagePropData.drawerWidth || 256"
      :height="drawerPropData.height ||pagePropData.drawerHeight || 256"
      :zIndex="pagePropData.drawerZIndex || 1000"
      :wrapClassName="
        (pagePropData.drawerWrapClassName || '') + ' idm_module_setting_drawer'
      "
      :visible="drawerVisible"
      @close="drawerOnClose"
      :afterVisibleChange="drawerOnAfterVisibleChange"
    >
      <iframe
        class="idm_drawer_iframe_basestyle"
        :src="drawerIframeUrl"
        name="idm_drawer_iframe"
      />
    </idm-a-drawer>
    <idm-a-modal
      v-else
      :visible="drawerVisible"
      :title="(pagePropData.drawerTitleShow||drawerPropData.showTitle===true)&&drawerPropData.showTitle!==false  ? drawerPropData.title||pagePropData.drawerTitle : ''"
      @cancel="drawerOnClose"
      :footer="null"
      :wrapClassName="
        (pagePropData.drawerWrapClassName || '') + ' idm_module_setting_drawer'
      "
      :zIndex="pagePropData.drawerZIndex || 1000"
      :width="drawerPropData.width ||pagePropData.drawerWidth || 256"
      :centered="pagePropData.drawerCentered === true"
      :mask="pagePropData.drawerMask === false ? false : true"
      :maskClosable="pagePropData.drawerMaskClosable === false ? false : true"
      :keyboard="pagePropData.drawerKeyboarde === false ? false : true"
      :maskStyle="
        commonCustomEventFunHandle(pagePropData, 'drawerMaskStyleFunction') || {}
      "
      :dialogStyle="commonCustomEventFunHandle(pagePropData, 'drawerStyleFunction') || {}"
      :bodyStyle="
        commonCustomEventFunHandle(pagePropData, 'drawerBodyStyleFunction') || {}
      "
      :destroyOnClose="pagePropData.drawerDestroyOnClose"
      :closable="pagePropData.drawerClosable === false ? false : true"
      :afterClose="drawerOnAfterVisibleChange"
    >
      <iframe
        class="idm_drawer_iframe_basestyle"
        :style="{ height: drawerPropData.height||pagePropData.drawerHeight || '256px' }"
        :src="drawerIframeUrl"
        name="idm_drawer_iframe"
      />
    </idm-a-modal>
  </div>
</template>

<script>
//页面渲染引擎所需要的组件注册
import "@/plugins/preview";
import mixin from "./mixin";
import Page from "./Page.vue";
export default {
  mixins: [mixin],
  name: "Preview",
  components: { Page },
  data() {
    return {
      pageid: "",
      //当前页面的数据
      PageSettingData: {},
      dialogVisibleStatus: false,
      //是否正在隐藏中
      dialogIsHideing: false,
      //窗口的对象
      dialogObjectList: [],
      //控制中心窗口是否显示
      drawerVisible: false,
      //控制中心窗口iframe的URL
      drawerIframeUrl: "",
      //控制中心窗口的option
      drawerControlSetPanelOption: null,
      //页面属性
      pagePropData: {},
      //控制中心弹窗属性
      drawerPropData: {},
      //当前页面所有加载过的页面数据
      AppPageList: [],
      //当前路由页面的动画类型，1：前进，0：后退
      currentTransitionType: 1,
      //公共资源是否加载完成
      commonRequireJsCssLoaded: false,
    };
  },
  mounted() {
    this.windowResizeEvent(function () {
      //给所有组件发送pageResize消息
      IDM.broadcast.send({
        type: "pageResize",
        rangeModule: "",
        message: IDM.getClientWH(),
      });
    });
  },
  created() {
    IDM.router.pageDataCachePool = IDM.cachePool(100);
    //加载引用外部脚本
    this.initCommonRequireJsCss(() => {
      this.commonRequireJsCssLoaded = true;
    });
    if (IDM.setting.applications.faviconIcoSrc) {
      try {
        document.head
          .querySelector("link[rel='icon']")
          .setAttribute(
            "href",
            IDM.url.getWebPath(IDM.setting.applications.faviconIcoSrc)
          );
      } catch (error) {}
    }

    this.pageid = this.$route.params.pageid;
    this.AppPageList.push({
      routerId: "",
      pageid: this.pageid,
      devpreview: this.pageid == "devpreview",
      display: true,
      mainPage: true,
      keep: true,
    });

    this.injectInnerActionToWindow();
  },
  methods: {
    /**
     * 窗口大小更改事件
     */
    windowResizeEvent(callback) {
      let that = this;
      window.onresize = function () {
        var target = this;
        that.executePageResize();
        if (target.resizeFlag) {
          clearTimeout(target.resizeFlag);
        }
        target.resizeFlag = setTimeout(function () {
          callback();
          target.resizeFlag = null;
        }, 100);
      };
    },
    /**
     * 调用执行page内部的resize事件
     */
    executePageResize() {
      for (let index = 0; index < this.AppPageList.length; index++) {
        const element = this.AppPageList[index];
        let idmPageRefs = this.$refs["idm_page_" + element.routerId];
        idmPageRefs instanceof Array ? (idmPageRefs = idmPageRefs[0]) : null;
        idmPageRefs.pageResize && idmPageRefs.pageResize(IDM.getClientWH());
      }
    },
    /**
     * 主页面配置数据
     */
    async mainPageSettingHandle(mainPageSetting) {
      this.PageSettingData = mainPageSetting;
      await this.loadPageElement();
    },
    /**
     * 控制中心抽屉关闭事件
     */
    drawerOnClose() {
      this.drawerVisible = false;
      this.commonCustomEventFunHandle(null, "drawerCloseFunction");
    },
    /**
     * 控制中心切换抽屉时动画结束后的回调
     */
    drawerOnAfterVisibleChange(event) {
      this.commonCustomEventFunHandle(null, "drawerAfterVisibleChangeFunction", {
        drawerVisible: event ? event : false
      });
    },
    injectInnerActionToWindow() {
      window.IdmBuiltin_OpenControlSetPanel = this.IdmBuiltin_OpenControlSetPanel;
      window.IdmBuiltin_CloseControlSetPanel = this.IdmBuiltin_CloseControlSetPanel;
      window.IdmBuiltin_OpenUrl = this.IdmBuiltin_OpenUrl;
      window.IdmBuiltin_OpenDialog = this.IdmBuiltin_OpenDialog;
      window.IdmBuiltin_CloseDialog = this.IdmBuiltin_CloseDialog;
      window.IdmBuiltin_ShowModule = this.IdmBuiltin_ShowModule;
      window.IdmBuiltin_HideModule = this.IdmBuiltin_HideModule;
      window.IdmBuiltin_InitNewPage = this.IdmBuiltin_InitNewPage;
      window.IdmBuiltin_backPage = this.IdmBuiltin_backPage;
      window.IdmBuiltin_changePageUserDefinedStatus = this.IdmBuiltin_changePageUserDefinedStatus;
      window.IdmBuiltin_executeUserDefinedEvent = this.IdmBuiltin_executeUserDefinedEvent;
      window.IdmBuiltin_executeComponentMoveIndexEvent = this.IdmBuiltin_executeComponentMoveIndexEvent;
    },
    IdmBuiltin_executeComponentMoveIndexEvent(ctx) {
      var customRouterId = ctx ? ctx.routerId || "" : "";
      for (let index = 0; index < this.AppPageList.length; index++) {
        const element = this.AppPageList[index];
        if (customRouterId != element.routerId) {
          continue;
        }
        let idmPageRefs = this.$refs["idm_page_" + element.routerId];
        idmPageRefs instanceof Array ? (idmPageRefs = idmPageRefs[0]) : null;
        idmPageRefs.componentMoveIndexHandle(ctx);
      }
    },
    IdmBuiltin_changePageUserDefinedStatus(ctx) {
      var customRouterId = ctx ? ctx.routerId || "" : "";
      for (let index = 0; index < this.AppPageList.length; index++) {
        const element = this.AppPageList[index];
        if (customRouterId != element.routerId) {
          continue;
        }
        let idmPageRefs = this.$refs["idm_page_" + element.routerId];
        idmPageRefs instanceof Array ? (idmPageRefs = idmPageRefs[0]) : null;
        idmPageRefs.pageUserDefinedStatusChangeHandle(ctx.status, ctx.save);
      }
    },
    IdmBuiltin_executeUserDefinedEvent(ctx, eventType) {
      var customRouterId = ctx ? ctx.routerId || "" : "";
      for (let index = 0; index < this.AppPageList.length; index++) {
        const element = this.AppPageList[index];
        if (customRouterId != element.routerId) {
          continue;
        }
        let idmPageRefs = this.$refs["idm_page_" + element.routerId];
        idmPageRefs instanceof Array ? (idmPageRefs = idmPageRefs[0]) : null;
        switch (eventType) {
          case "save":
            idmPageRefs.userDefinedSave();
            break;
          case "reset":
            idmPageRefs.userDefinedReset();
            break;
          case "quit":
            idmPageRefs.userDefinedQuit();
            break;
        }
      }
    },
    transitionAfterEnter() {
      // $(window).scrollTop(0);
    },
    /**
     * 内部的加载新页面事件
     */
    IdmBuiltin_InitNewPage(routerObject) {
      this.AppPageList.push({
        routerId: routerObject.routerId,
        pageid: routerObject.next,
        devpreview: routerObject.next == "devpreview",
        mainPage: false,
        keep: true,
        display: true,
        scrollTop: $(window).scrollTop(),
      });
      //todo 这里需要实现判断当前路由页面缓存方式，并且做出是缓存dom方式还是移除dom
      let nokeep = false;
      if (routerObject.meta && routerObject.meta.keep === false) {
        //不缓存
        this.AppPageList[this.AppPageList.length - 2].keep = false;
        nokeep = true;
      } else if (routerObject.meta && routerObject.meta.keep === "memory") {
        //缓存dom到内存中(暂不支持)
        const _routerId = this.AppPageList[this.AppPageList.length - 2].routerId;
        // IDM.router.setDomToCache(_routerId);
        nokeep = true;
      }
      $(window).scrollTop(0);
      if (!nokeep) {
        setTimeout(() => {
          //如果是缓存，需要执行隐藏
          try {
            this.AppPageList[this.AppPageList.length - 2].display = false;
          } catch (e) {
            //页面切换速度过快引起的，比如打开里面关闭了而这里延时隐藏还没执行导致的索引报错。
          }
        }, 600);
      }
      nokeep &&
        this.$nextTick(() => {
          //卸载后触发的事件
          var pageSetData = IDM.router.pageDataCachePool.get(routerObject.from);
          if (pageSetData) {
            var propData = null;
            for (var index = 0; index < pageSetData.page.componentsMap.length; index++) {
              const item = pageSetData.page.componentsMap[index];
              if (item.packageid == pageSetData.page.layout.packageid) {
                propData = item.props.compositeAttr;
                break;
              }
            }
            IDM.router.commonCustomEventFunHandle(
              propData,
              "pageNoKeepDestroyedFunction",
              routerObject,
              this.AppPageList[this.AppPageList.length - 2].pageid
            );
          }
        });
    },
    IdmBuiltin_backPage(router, prevRoter) {
      let activeItem = null;
      for (let index = 0; index < this.AppPageList.length; index++) {
        let item = this.AppPageList[index];
        if (item.routerId == router.routerId) {
          this.AppPageList.splice(index, 1);
        }
        if (
          router &&
          router.meta.keep === false &&
          ((prevRoter && prevRoter.routerId == item.routerId) ||
            (!prevRoter && item.mainPage))
        ) {
          //重新渲染
          item.keep = true;
        }
        if (
          (prevRoter && prevRoter.routerId == item.routerId) ||
          (!prevRoter && item.mainPage)
        ) {
          activeItem = item;
          item.display = true;
          $(window).scrollTop(item.scrollTop);
        }
      }
      this.$nextTick(() => {
        //卸载后触发的事件
        let pageSetData = IDM.router.pageDataCachePool.get(router.next);
        var propData = null;
        if (pageSetData) {
          for (var index1 = 0; index1 < pageSetData.page.componentsMap.length; index1++) {
            const item = pageSetData.page.componentsMap[index1];
            if (item.packageid == pageSetData.page.layout.packageid) {
              propData = item.props.compositeAttr;
              break;
            }
          }
          IDM.router.commonCustomEventFunHandle(
            propData,
            "pageBackDestroyedFunction",
            router,
            router.next
          );
        }
        IDM.broadcast.unRegisterModule(router.routerId);
        //触发页面激活事件
        pageSetData = IDM.router.pageDataCachePool.get(activeItem.pageid);
        if (pageSetData) {
          for (var index2 = 0; index2 < pageSetData.page.componentsMap.length; index2++) {
            const item = pageSetData.page.componentsMap[index2];
            if (item.packageid == pageSetData.page.layout.packageid) {
              propData = item.props.compositeAttr;
              break;
            }
          }
          IDM.router.commonCustomEventFunHandle(
            propData,
            "pageActivatedFunction",
            prevRoter,
            activeItem.pageid
          );
          this.sendBroadcastMessage(
            {
              type: "pageActivated",
              message: activeItem,
            },
            activeItem.routerId
          );
        }
      });
    },
    /**
     * 打开组件控制面板设置
     * {
     *   controlSetPanelOption:{
     *     url:"要展示的页面地址，如果为空则使用页面设置的默认地址",
     *     param:{
     *        marketModuleId:"必填，市场组件的ID，组件内取this.moduleObject.comId即可",
     *        pageId:"必填，页面的ID，直接使用 window.IDM.broadcast.pageModule.id 即可获取",
     *        packageid:"必填，组件实例的ID，主要用于区别页面的同一个组件，直接使用 this.moduleObject.packageid 即可获取到"
     *     },
     *     showTop:默认为true，设置是否显示在最顶级页面中，这样做的目的是为了在跨页面的时候遮罩显示在最外面，能覆盖整个窗口
     *     success:层弹出后的成功回调方法,
     *     yes:确定按钮回调方法,
     *     cancel:关闭触发的回调,
     *     reset:重置后的回调,
     *     other:其他按钮触发回调方法,
     *     controlSetPanelId:"控制面板窗口ID,每次打开的时候自动生成"
     *   }
     * }
     */
    IdmBuiltin_OpenControlSetPanel(ctx) {
      let iframeUrl = this.pagePropData.moduleControlCenterSettingUrl;
      //生成url
      if (!iframeUrl && !ctx.controlSetPanelOption?.url) {
        return;
      }
      iframeUrl = iframeUrl + (iframeUrl.indexOf("?") == -1 ? "?" : "&");
      if (ctx && ctx.controlSetPanelOption) {
        if (
          ctx.controlSetPanelOption.param &&
          ctx.controlSetPanelOption.param.marketModuleId &&
          ctx.controlSetPanelOption.param.pageId &&
          ctx.controlSetPanelOption.param.packageid
        ) {
          Object.keys(ctx.controlSetPanelOption.param).forEach((key, index) => {
            if (index > 0) {
              iframeUrl = iframeUrl + "&";
            }
            iframeUrl = iframeUrl + key + "=" + ctx.controlSetPanelOption.param[key];
          });
        } else {
          return;
        }
      }
      if (ctx.controlSetPanelOption?.url) {
        iframeUrl = ctx.controlSetPanelOption.url;
      }
      this.drawerPropData = ctx.controlSetPanelOption;
      const controlPanelId = ctx.controlSetPanelOption?.controlSetPanelId;
      if (controlPanelId) {
        iframeUrl =
          iframeUrl +
          (iframeUrl.indexOf("?") == -1 ? "?" : "&") +
          "controlPanelId=" +
          controlPanelId;
      }
      this.drawerIframeUrl = IDM.url.getWebPath(iframeUrl);
      //设置对应的option
      this.drawerControlSetPanelOption = ctx.controlSetPanelOption || null;
      this.drawerVisible = true;
      //执行打开成功的回调方法
      this.drawerControlSetPanelOption &&
        this.drawerControlSetPanelOption.success &&
        this.drawerControlSetPanelOption.success(
          ctx.controlSetPanelOption?.controlSetPanelId
        );
    },
    /**
     * 关闭组件控制面板设置，这里要判断controlSetPanelId是否与当前页面的一致，一致才能关闭
     * {
     *   controlSetPanelOption:{
     *     controlSetPanelId:"控制面板窗口ID"
     *   }
     * }
     */
    IdmBuiltin_CloseControlSetPanel(ctx) {
      const controlSetPanelId = IDM.type(ctx.controlSetPanelOption)==="string"?ctx.controlSetPanelOption:ctx.controlSetPanelOption&&ctx.controlSetPanelOption?.controlSetPanelId;
      if (
        (ctx && ctx.innerClose) ||
        (ctx &&
        controlSetPanelId &&
          this.drawerControlSetPanelOption &&
          controlSetPanelId ==
            this.drawerControlSetPanelOption?.controlSetPanelId)
      ) {
        //是关闭这个窗口，执行关闭事件
        this.drawerOnClose();
        //判断关闭的类型
        switch (ctx.actionType) {
          case "close":
          case "other":
            this.drawerControlSetPanelOption &&
              this.drawerControlSetPanelOption.other &&
              this.drawerControlSetPanelOption.other();
            break;
          case "commit":
            this.drawerControlSetPanelOption &&
              this.drawerControlSetPanelOption.yes &&
              this.drawerControlSetPanelOption.yes();
            break;
          case "reset":
            this.drawerControlSetPanelOption &&
              this.drawerControlSetPanelOption.reset &&
              this.drawerControlSetPanelOption.reset();
            break;
        }
      }
    },
    /**
     * 打开地址
     */
    IdmBuiltin_OpenUrl(ctx) {
      var customParam = ctx.customParam ? ctx.customParam : ctx;
      window.open(
        IDM.url.getWebPath(customParam.openUrl),
        customParam.openName,
        customParam.openFeatures
      );
    },
    /**
     * 打开窗口
     * 要给对应的组件发送打开窗口的消息
     */
    IdmBuiltin_OpenDialog(ctx) {
      var customParam = ctx.customParam ? ctx.customParam : ctx;
      var customRouterId = ctx.routerId || "";
      var moduleIdArray = [];
      let existsCount = 0;
      let hasIdmPageRefs = [];
      customParam.targetModule.forEach((item) => {
        moduleIdArray.push(item.moduleId);
        //这里this.renderDialog需要调用页面组件挨个去加载
        for (let index = 0; index < this.AppPageList.length; index++) {
          const element = this.AppPageList[index];
          if (customRouterId != element.routerId) {
            continue;
          }
          let idmPageRefs = this.$refs["idm_page_" + element.routerId];
          idmPageRefs instanceof Array ? (idmPageRefs = idmPageRefs[0]) : null;
          const dialogObject = idmPageRefs.renderDialog(item.moduleId);
          if (dialogObject === false) {
            continue;
          }
          hasIdmPageRefs.push(idmPageRefs);
          dialogObject.dialogIsHideing = false;
          if (ctx.layerOption) {
            dialogObject.layerOption = ctx.layerOption;
          }
          //追加到窗口集合中
          this.dialogObjectList.push(dialogObject);
          existsCount++;
          idmPageRefs.setShowDialog(dialogObject);
        }
      });
      //没有找到其中一个就不往下加载了
      if (existsCount == 0) {
        return;
      }
      let that = this;
      this.$nextTick(function () {
        //这里即使发送消息也没关系（会存储在等候消息池中），因为会等待组件加载完成再次调用发送消息
        setTimeout(() => {
          that.sendBroadcastMessage({
            type: "linkageOpenDialog",
            message: ctx,
            rangeModule: moduleIdArray,
          });
        }, 5);
      });
      if (ctx.callback) {
        ctx.callback();
      }
    },
    /**
     * 关闭窗口
     * 要给对应的组件发送关闭窗口的消息
     */
    IdmBuiltin_CloseDialog(ctx) {
      var customRouterId = ctx.routerId || "";
      for (let index = 0; index < this.AppPageList.length; index++) {
        const element = this.AppPageList[index];
        if (customRouterId != element.routerId) {
          continue;
        }
        let idmPageRefs = this.$refs["idm_page_" + element.routerId];
        idmPageRefs instanceof Array ? (idmPageRefs = idmPageRefs[0]) : null;
        idmPageRefs.closeThisOpenDialog(ctx);
      }
    },
    /**
     * 显示组件
     * 直接用packageid隐藏
     */
    IdmBuiltin_ShowModule(ctx) {
      var customParam = ctx.customParam ? ctx.customParam : ctx;
      var customRouterId = ctx.routerId || "";
      var moduleIdArray = [];
      let noExistsModuleIdList = [];
      customParam.targetModule.forEach((item) => {
        moduleIdArray.push(item.moduleId);
        let currentModule = $(
          (customRouterId ? "#router_page_" + customRouterId + " " : "") +
            "#" +
            item.moduleId
        );
        if (currentModule && currentModule.length == 0) {
          noExistsModuleIdList.push(item.moduleId);
        } else {
          currentModule.show();
        }
      });
      if (noExistsModuleIdList.length) {
        let idmPageRefs = this.$refs["idm_page_" + customRouterId];
        if (idmPageRefs) {
          idmPageRefs instanceof Array ? (idmPageRefs = idmPageRefs[0]) : null;
          idmPageRefs.showHideNoLoadModule(noExistsModuleIdList);
        }
      }
      this.sendBroadcastMessage({
        type: "linkageShowModule",
        message: ctx,
        rangeModule: moduleIdArray,
      });
      if (ctx.callback) {
        ctx.callback();
      }
    },
    /**
     * 隐藏组件
     * 直接用packageid显示
     */
    IdmBuiltin_HideModule(ctx) {
      var customParam = ctx.customParam ? ctx.customParam : ctx;
      var customRouterId = ctx.routerId || "";
      var moduleIdArray = [];
      customParam.targetModule.forEach((item) => {
        moduleIdArray.push(item.moduleId);
        $(
          (customRouterId ? "#router_page_" + customRouterId + " " : "") +
            "#" +
            item.moduleId
        ).hide();
      });
      this.sendBroadcastMessage({
        type: "linkageHideModule",
        message: ctx,
        rangeModule: moduleIdArray,
      });
      if (ctx.callback) {
        ctx.callback();
      }
    },
    /**
     * 微信的jssdk加载处理函数
     */
    weixinEventHandle(propDataObject) {
      let that = this;
      let propData = propDataObject.compositeAttr;
      if (propData.switchWeixinJSSDK) {
        //加载微信的jssdk
        let requireJsCss = IDM.setting.weixin.requireJsCss;
        if (requireJsCss && IDM.type(requireJsCss) == "string") {
          requireJsCss = [requireJsCss];
        }
        if (requireJsCss && IDM.setting.weixin.signatureUrl) {
          var newArray = [];
          requireJsCss.forEach((item) => newArray.push(IDM.url.getWebPath(item)));
          IDM.http
            .importFiles(newArray)
            .then(() => {
              // alert("加载微信requireJsCss文件完成")
              //加载完成
              console.log("加载微信requireJsCss文件完成", newArray);
              //请求接口
              IDM.http
                .get(IDM.setting.weixin.signatureUrl, {
                  url: window.location.href.split("#")[0],
                })
                .then((res) => {
                  // alert(JSON.stringify(res.data))
                  let resData = res.data;
                  if (resData.code == "200" && resData.data) {
                    resData = resData.data;
                  }
                  //政务微信的文档 http://im.sdt.sdbdc.cn:9080/api/doc#18026
                  wx.config({
                    beta: true, // 调用wx.invoke形式的接口值时，该值必须为true。
                    debug: IDM.setting.weixin.debug === true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: resData.appId, // 必填，山东通的cropID
                    timestamp: resData.timestamp, // 必填，生成签名的时间戳
                    nonceStr: resData.nonceStr, // 必填，生成签名的随机串
                    signature: resData.signature, // 必填，签名，见附录1
                    jsApiList: IDM.setting.weixin.jsApiList, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                  });
                  wx.ready(() => {
                    //处理属性自定义函数
                    var commonFunction = propData.weixinReadyFunction;
                    commonFunction &&
                      commonFunction.forEach((item) => {
                        try {
                          window[item.name] &&
                            window[item.name].call(this, {
                              ...that.commonParam(),
                              customParam: item.param,
                              _this: this,
                            });
                        } catch (error) {}
                      });
                  });
                  wx.error((resError) => {
                    //处理属性自定义函数
                    var commonFunction = propData.weixinErrorFunction;
                    commonFunction &&
                      commonFunction.forEach((item) => {
                        try {
                          window[item.name] &&
                            window[item.name].call(this, {
                              ...that.commonParam(),
                              customParam: item.param,
                              _this: this,
                              error: resError,
                            });
                        } catch (error) {}
                      });
                  });
                })
                .catch(function (error) {
                  console.log("微信授权出错", error);
                  // alert(JSON.stringify(error))
                });
            })
            .catch((err) => {
              // alert("加载微信requireJsCss文件出错")
              console.log("加载微信requireJsCss文件出错");
            });
        }
      }
    },
    /**
     * websocket事件处理函数
     */
    webSocketEventHandle(propDataObject) {
      let that = this;
      let propData = propDataObject.compositeAttr;
      if (propData.switchWebSocket) {
        //初始化
        that.websocketInvert = setInterval(() => {
          if (that.commonRequireJsCssLoaded) {
            if (
              propData.websocketInitName &&
              typeof window[propData.websocketInitName] == "function"
            ) {
              window[propData.websocketInitName]();
            }
            clearInterval(that.websocketInvert);
          }
        }, 1000);
        //打开监听
        propData.websocketOpenEvent
          ? (window[propData.websocketOpenEvent] = function () {
              //处理属性自定义函数
              var commonFunction = propData.websocketOpenFunction;
              commonFunction &&
                commonFunction.forEach((item) => {
                  try {
                    window[item.name] &&
                      window[item.name].call(this, {
                        ...that.commonParam(),
                        customParam: item.param,
                        _this: this,
                      });
                  } catch (error) {}
                });
            })
          : null;
        //消息监听
        propData.websocketMessageEvent
          ? (window[propData.websocketMessageEvent] = function (msgData) {
              //发送websocket消息
              IDM.broadcast.send({
                type: "websocket",
                rangeModule: "",
                globalSend: true,
                message: msgData,
              });
              //处理属性自定义函数
              var commonFunction = propData.websocketMessageFunction;
              commonFunction &&
                commonFunction.forEach((item) => {
                  try {
                    window[item.name] &&
                      window[item.name].call(this, {
                        ...that.commonParam(),
                        customParam: item.param,
                        msgData,
                        _this: this,
                      });
                  } catch (error) {}
                });
            })
          : null;
      }
    },
    /**
     * 加载引用外部脚本
     */
    initCommonRequireJsCss(callback) {
      //加载默认通用脚本
      if (
        IDM.setting.applications.commonRequireJsCss &&
        IDM.setting.applications.commonRequireJsCss instanceof Array
      ) {
        var newArray = [];
        IDM.setting.applications.commonRequireJsCss.forEach((item) =>
          newArray.push(IDM.url.getWebPath(item))
        );
        try {
          IDM.http
            .importFiles(newArray)
            .then(() => {
              //加载完成
              console.log(
                "加载commonRequireJsCss文件完成",
                IDM.setting.applications.commonRequireJsCss
              );
              callback && callback();
            })
            .catch((err) => {
              console.log("加载commonRequireJsCss文件出错");
              callback && callback();
            });
        } catch (err) {
          console.error("加载commonRequireJsCss文件脚本内部出错");
          callback && callback();
        }
      } else {
        callback && callback();
      }
    },
    /**
     * 只有开启了才加载
     * 加载下拉刷新插件
     */
    initPulltorefreshPlugin() {
      let that = this;
      let propData = this.PageSettingData.page.layout.props.compositeAttr;
      if (!propData.openPulltorefresh) {
        IDM.page.stopPullToRefresh();
        return;
      }
      IDM.http
        .importFiles([IDM.url.getWebPath("~/lib/pulltorefreshjs/index.umd.min.js")])
        .then(() => {
          //加载完成
          console.log("加载pulltorefreshjs文件完成");
          try {
            const ptr = PullToRefresh.init({
              mainElement: "body",
              // triggerElement:".idm_page_root",
              instructionsPullToRefresh: "下拉刷新",
              instructionsReleaseToRefresh: "松手刷新",
              instructionsRefreshing: "刷新中",
              onRefresh() {
                that.initPulltorefreshHandle();
              },
              shouldPullToRefresh: function () {
                // console.log(this)
                // console.log("this.mainElement.scrollTop",this.mainElement.scrollTop)
                // debugger
                return IDM.page.getPullToRefreshStatus() && !$(window).scrollTop();
              },
            });
            IDM.page.startPullToRefresh(ptr);
          } catch (error) {
            console.log("加载pulltorefreshjs出错", error);
          }
        })
        .catch((err) => {
          console.error("加载pulltorefreshjs文件出错", err);
        });
    },
    /**
     * 下拉刷新触发函数
     */
    initPulltorefreshHandle() {
      //检测当前显示的最后一个页面
      let currentShowPageId = this.AppPageList[this.AppPageList.length - 1].pageid;
      let currentRouterId = this.AppPageList[this.AppPageList.length - 1].routerId;
      let _PageSettingData =
        IDM.router.pageDataCachePool.get(currentShowPageId) || this.PageSettingData;
      let propData = _PageSettingData.page.layout.props.compositeAttr;
      switch (propData.pulltorefreshType) {
        case "page":
          //刷新页面
          window.location.reload();
          break;
        case "data":
          // this.fetchUserInfo(propData,true,true);
          try {
            let idmPageRefs = this.$refs["idm_page_" + currentRouterId];
            idmPageRefs instanceof Array ? (idmPageRefs = idmPageRefs[0]) : null;
            idmPageRefs.fetchUserInfo(propData, true, true, true);
          } catch (err) {}
          break;
        case "custom":
          //自定义
          var customFunction = propData.pulltorefreshFunction;
          customFunction &&
            customFunction.forEach((item) => {
              window[item.name] &&
                window[item.name].call(this, {
                  customParam: item.param,
                });
            });
          break;
      }
    },
    /**
     * 加载console插件
     */
    initVconsolePlugin() {
      let propData = this.PageSettingData.page.layout.props.compositeAttr;
      let showVconsole = propData.showVconsole;
      if (showVconsole) {
        IDM.http
          .importFiles([IDM.url.getWebPath("~/lib/vconsole/vconsole.min.js")])
          .then(() => {
            //加载完成
            var vConsole = new window.VConsole();
          })
          .catch((err) => {
            console.log("加载vconsole插件出错");
          });
      }
    },
    /**
     * 加载进度条动画资源
     */
    initLoadbarResource() {
      //判断是否已经加载过

      let propData = this.PageSettingData.page.layout.props.compositeAttr;
      if (!propData.openPreviewLoadStyle) {
        //加载完成
        idmPace.stop();
        return;
      }
      //设置颜色
      let previewLoadColor = propData.previewLoadColor;
      if (previewLoadColor && previewLoadColor.hex8) {
        document.documentElement.style.setProperty(
          `--idmPreviewLoadColor`,
          IDM.hex8ToRgbaString(previewLoadColor.hex8)
        );
      }

      IDM.http
        .importFiles([
          IDM.url.getWebPath("~/lib/pace/pace.min.js"),
          IDM.url.getWebPath("~/lib/pace/minimal.css"),
        ])
        .then(() => {
          //加载完成
          idmPace.stop();
          Pace.start();
        })
        .catch((err) => {
          console.log("加载进度条文件出错");
        });
    },
    /**
     * 加载页面组件
     */
    async loadPageElement() {
      this.pagePropData = this.PageSettingData.page.layout.props.compositeAttr;
      //进度条颜色以主页面为准
      this.initLoadbarResource();
      //日志以主页面为准
      this.initVconsolePlugin();

      //websocket事件处理函数
      this.webSocketEventHandle(this.PageSettingData.page.layout.props);
      //微信jssdk处理函数
      this.weixinEventHandle(this.PageSettingData.page.layout.props);
      //加载下拉刷新，先判断属性是否需要加载下拉刷新功能
      this.initPulltorefreshPlugin();
    },
  },
  watch: {
    $route(to, from) {
      if (IDM.router.idmInnerRouterEvent) {
        IDM.router.idmInnerRouterEvent = false;
      } else {
        //是浏览器前进或者后退触发的，需要取操作内部事件
        console.log("🚀 ~ file: Preview.vue ~ line 861 ~ $route ~ from", from);
        console.log("🚀 ~ file: Preview.vue ~ line 861 ~ $route ~ to", to);
        IDM.router.innerRouterChangeEvent(to, from);
        // debugger;
      }

      //路由发生了变化，需要去加载子级页面，同时要取出是否缓存本页面
      //要监听返回对比，然后去渲染子页面
      // debugger
      // 对路由变化作出响应...
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      // if(to.meta.index > from.meta.index) {
      //   //设置动画名称
      //   this.currentTransitionType = 1;
      // }else{
      //   this.currentTransitionType = -1;
      // }
    },
  },
};
</script>
<style lang="scss">
html,
body {
  height: auto !important;
}
html,
body,
body > div.idm-root-element,
body > div .idm_render_engine_container,
body > div .idm_render_engine_router_container,
body > div .idm_render_engine_page_container,
body > div .idm_render_engine_page_content,
body > div .idm_render_engine_container .idm_page_root {
  min-height: 100vh;
  position: relative;
}
body > div.idm-root-element,
body > div .idm_render_engine_container,
body > div .idm_render_engine_router_container,
body > div .idm_render_engine_page_container,
body > div .idm_render_engine_page_content {
  height: 100%;
}
.idm_render_engine_container .idm_page_root {
  overflow: auto;
}
/**
控制中心抽屉
*/
.idm_module_setting_drawer {
  .idm-ant-drawer-wrapper-body {
    display: flex;
    flex-direction: column;
    .idm-ant-drawer-body {
      flex-grow: 2;
      padding: 0;
      line-height: 0 !important;
    }
  }
  .idm-ant-modal-body {
    padding: 0;
  }
  .idm_drawer_iframe_basestyle {
    border: none;
    width: 100%;
    height: 100%;
  }
}

/*
悬浮布局层
*/
.idm_hover_layer_wrap_preview {
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  z-index: 58;
  pointer-events: none;
  * {
    pointer-events: auto;
  }
  .idm_flow_endpoint {
    opacity: 0;
    cursor: default;
  }
  .idm-overlay-label {
    z-index: 99999;
  }
  > .idm_module.idm_module_absolute {
    pointer-events: none !important;
  }
}
body > .idm_flow_endpoint {
  opacity: 0;
  cursor: default;
  display: none;
}
/*
模态窗口容器
*/
.idm_dialog_wrap_preview {
  position: fixed;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  z-index: 59;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // animation:idm_dialog_wrap_shade_animation 0.3s;
  /*Safari and Chrome*/
  // -webkit-animation:idm_dialog_wrap_shade_animation 0.3s;
  .idm_dialog_shade_layer {
    // background: transparent;
    background-color: rgba(0, 0, 0, 0.4);
    animation: idm_dialog_wrap_shade_animation 0.3s;
    /*Safari and Chrome*/
    -webkit-animation: idm_dialog_wrap_shade_animation 0.3s;
    // z-index: 0;
    &[hideing="hideing"] {
      animation: idm_dialog_wrap_shade_animation_hide 0.52s;
      /*Safari and Chrome*/
      -webkit-animation: idm_dialog_wrap_shade_animation_hide 0.52s;
    }
  }
  & > div {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
  }
  & > div.idm_module {
    display: none;
    pointer-events: none;
    & > div {
      pointer-events: auto;
    }
    &.topLeft {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
    }
    &.topCenter {
      display: flex;
      align-items: flex-start;
      justify-content: center;
    }
    &.topRight {
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
    }
    &.centerLeft {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    &.center {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.centerRight {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    &.bottomLeft {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
    }
    &.bottomCenter {
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }
    &.bottomRight {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }
  }
  &[hideing="hideing"] {
    animation: idm_dialog_wrap_shade_animation_hide 0.52s;
    /*Safari and Chrome*/
    -webkit-animation: idm_dialog_wrap_shade_animation_hide 0.52s;
  }
}
@keyframes idm_dialog_wrap_shade_animation {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@-webkit-keyframes idm_dialog_wrap_shade_animation /*Safari and Chrome*/ {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes idm_dialog_wrap_shade_animation_hide {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@-webkit-keyframes idm_dialog_wrap_shade_animation_hide /*Safari and Chrome*/ {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@import "../style/core/layer.scss";

.slide-fade-enter,
.slide-fade-leave-to {
  left: 0;
  top: 0;
  right: 0;
  position: absolute;
  transform: translateX(100%);
}
.slide-fade-enter-active {
  background-color: white;
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s ease;
  background-color: white;
  transform: translateX(100%);
  z-index: 100;
}

.idm_render_engine_page_container + .idm_render_engine_page_container {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  background-color: white;
}
</style>
